module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian.component.scss
// module id = ./src/app/features/accordian/accordian.component.scss
// module chunks = main